.base {
	display: flex;
	border-radius: var(--lp-border-radius-medium);
	gap: var(--lp-spacing-500);
	align-items: flex-start;

	&.error .icon {
		fill: var(--lp-color-fill-feedback-error);
	}

	&.info .icon {
		fill: var(--lp-color-fill-feedback-info);
	}

	&.success .icon {
		fill: var(--lp-color-fill-feedback-success);
	}

	&.warning .icon {
		fill: var(--lp-color-brand-orange-base);
	}
}

.default {
	padding: var(--lp-spacing-700);
	background-color: var(--lp-color-bg-ui-primary);
	border: 1px solid var(--lp-color-border-ui-primary);
	position: relative;

	&.neutral {
		--color-1: var(--lp-color-gray-500);
		--color-2: var(--lp-color-gray-400);
	}

	&.error {
		--color-1: var(--lp-color-red-500);
		--color-2: var(--lp-color-red-400);
	}

	&.info {
		--color-1: var(--lp-color-blue-500);
		--color-2: var(--lp-color-blue-400);
	}

	&.success {
		--color-1: var(--lp-color-green-500);
		--color-2: var(--lp-color-green-400);
	}

	&.warning {
		--color-1: var(--lp-color-brand-orange-base);
		--color-2: #ffb052;
	}

	&:has(.heading) {
		/* biome-ignore lint/style/noDescendingSpecificity: ignore */
		& .icon {
			transform: translateY(2px);
		}
	}

	& .close {
		position: absolute;
		right: var(--lp-spacing-300);
		top: var(--lp-spacing-500);
	}
}

.inline {
	align-items: center;
	gap: var(--lp-spacing-300);

	& .close {
		margin-left: var(--lp-spacing-300);
	}
}

.bar {
	position: absolute;
	background: linear-gradient(91deg, var(--color-1) 0%, var(--color-2) 100%);
	border-radius: calc(var(--lp-border-radius-medium) - 1px)
		calc(var(--lp-border-radius-medium) - 1px) 0 0;
	width: 100%;
	height: var(--lp-size-8);
	top: 0;
	left: 0;
}

.content {
	min-width: 0;
	flex: 1;
	display: flex;
	flex-direction: column;
	font: var(--lp-text-body-2-regular);
	align-items: flex-start;
}

.heading {
	font: var(--lp-text-heading-2-semibold);
	margin-bottom: var(--lp-spacing-200);
}

.buttonGroup {
	margin-top: var(--lp-spacing-700);
}
